<template functional>
  <!-- <div class="pt-1 pb-4">
    <div class="mt-3">
      <div
        class="p-1 border_1 border_bahama_blue v2_bg_primary_teal v2_color_white v2_font_size_32 v2_font_weight_semibold d-flex align-items-center justify-content-center"
      >
        <slot name="number" /> matches
      </div>
    </div>
  </div> -->
  <div class="border_1 border_light_teal h-100 w-100 pt-1 pb-1 px-2 mt-3">
    <div class="mt-3">
      <div class="font-weight-bold font_size_1125rem v3_color_teal mb-3 border_bottom_1 border_bottom_light_teal">
        Number of Matches
      </div>
      <div
        class="px-3 border_2 rounded_0 border_light_teal v3_bg_teal_03 v3_color_white font_size_2500rem min_height_100 d-flex align-items-center justify-content-center"
      >
        <span><slot name="number" /></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecruiterJobOffersMatching',
};
</script>

<style scoped />
